import { Box, Grid } from "@mui/material";
import { ReactNode, useState } from "react";
import Flex from "../../../../../components/Flex";
import { ScrollArea } from "../../../../../components/ScrollBar";
import ProviderProfileDrawer from "../../../../../components/app/ProviderProfileDrawer";
import CustomCard from "../../../../../components/app/settings/user-settings/CustomCard";
import AllUserTable from "../user-setting/AllUserTable";
import useDisclosure from "../../../../../hooks/use-disclosure";
import { useReduceDisclosure } from "../../../../../hooks/use-reduce-disclosure";
import { CurView } from "../../../admin/tenant-settings/tenant-providers";
import { useUsersList } from "../../../../../queries/use-get-users";
import { useOutletContext } from "react-router-dom";
import { useUpdateUser } from "../../../../../queries/use-update-user";
import {
  DEFAULT_PAGE_SIZE,
  getErrorSnackbar,
  getSuccessSnackbar,
  getUnNecessaryTransformData,
  getXtenantId,
  transformMultiSelectFrontEndVal,
} from "../../../../../utils/utils";
import UpsertStaffUserDrawer from "../../../../../components/app/admin/provider-groups/UpsertStaffUserDrawer";
import { useStatusUsers } from "../../../../../queries/use-status-users";
import { useUpdateProviderUserStatus } from "../../../../../queries/use-update-provider-status";
import { StaffUser } from "../../../../../constants/staff-user-schema";
import UserProfileDrawer from "../../../../../components/app/settings/user-settings/UserProfileDrawer";
import { useSnackbar } from "../../../../../hooks/useSnackbar";
import CustomTablePagination from "../../../../../components/CustomTablePagination";
import { GridPaginationModel } from "@mui/x-data-grid";
import Text from "../../../../../components/Text";
import { useGetUserDetail } from "../../../../../queries/use-get-pertiCular-user";
import { UserCardData } from "../../../../../types/user-types";

const UserDetails = () => {
  const { curView, statusKey, searchKey, isArchieved }: any =
    useOutletContext();

  const [selectedUserId, setSelectedUserId] = useState<string>();
  const { data: userDetail }: any = useGetUserDetail({
    userId: selectedUserId,
    xTENANTID: getXtenantId(),
    disable: !selectedUserId,
  });

  const { opened, open, close } = useDisclosure(false);

  const [
    userProfileModalDisclosure,
    providerProfileModal,
    providerUserModalDisclosure,
  ] = useReduceDisclosure(3);

  const [selectedUserData, setSelectedUserData] = useState<UserCardData | null>(
    null
  );
  const [modalTitle, setModalTitle] = useState<"Add New User" | "Edit User">(
    "Add New User"
  );

  // Pagination state for CustomTablePagination
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: DEFAULT_PAGE_SIZE,
  });

  const { data: UsersList, refetch } = useUsersList({
    pagination: paginationModel,
    searchKey,
    statusKey,
    isArchieve: isArchieved,
  });
  const { mutateAsync: updateStaffUser } = useUpdateUser();
  const { mutateAsync: statusChange } = useStatusUsers();
  const { mutateAsync: providerStatusUpdate } = useUpdateProviderUserStatus();
  const showSnackbar = useSnackbar();

  // Get pagination data from API response
  const totalElements = UsersList?.data?.page?.totalElements ?? 0;

  function handleOpenProfileModal() {
    userProfileModalDisclosure.open();
  }

  function handleOpenEditModal(userData: UserCardData) {
    setSelectedUserId(userData?.uuid);
    setSelectedUserData(userData as any);
    // Todo need to remove while check actual role where dummy role check added
    if ((userData as any)?.roleType !== "STAFF") {
      // to open the provider user form modal
      providerUserModalDisclosure.open();
      return;
    }

    setModalTitle("Edit User");
    open();
  }

  const editStaffUser = (values: StaffUser) => {
    const transFormData: any = getUnNecessaryTransformData(
      ["workLocations"],
      values
    );
    return updateStaffUser({
      user: transFormData,
      xTENANTID: getXtenantId(),
    }).then((res) => {
      refetch();
      return res;
    });
  };

  function handleStatusChange(
    userId: string,
    status: boolean,
    roleType: string
  ) {
    if (roleType === "STAFF") {
      return statusChange({
        userId,
        status,
        xTENANTID: getXtenantId(),
      })
        .then((res) => {
          refetch();
          showSnackbar(getSuccessSnackbar(res));
        })
        .catch((err) => {
          showSnackbar(getErrorSnackbar(err));
        });
    }

    return providerStatusUpdate({
      providerId: userId,
      status,
      xTENANTID: getXtenantId(),
    })
      .then((res) => {
        refetch();
        showSnackbar(getSuccessSnackbar(res));
      })
      .catch((err) => {
        showSnackbar(getErrorSnackbar(err));
      });
  }

  const ACTIVE_VIEW_MAPPER: Record<CurView, ReactNode> = {
    card_view: (
      <Grid container gap={1} justifyContent="center">
        {UsersList?.data?.content?.map((user) => {
          return (
            <Grid item key={user.value}>
              <CustomCard
                userData={user}
                handleOpenEditModal={() => handleOpenEditModal(user)}
                handleOpenProfileModal={() => {
                  setSelectedUserData(user as any);
                  user?.roleType === "STAFF"
                    ? handleOpenProfileModal()
                    : providerProfileModal.open();
                }}
                onStatusChange={() =>
                  handleStatusChange(
                    user.uuid,
                    !user.active,
                    user?.roleType ?? ""
                  )
                }
              />
            </Grid>
          );
        })}
      </Grid>
    ),
    table_view: (
      <AllUserTable
        userList={UsersList?.data?.content ?? []}
        searchKey={searchKey}
        refetch={refetch}
      />
    ),
  };
  {
    /* <Grid container gap={1} justifyContent="center">
          {usersData.map((user) => {
            return (
              <Grid item key={user.value}>
                <CustomCard
                  userData={user}
                  handleOpenEditModal={() => handleOpenEditModal(user)}
                  handleOpenProfileModal={() => {
                    user.role === "billing_staff"
                      ? handleOpenProfileModal(user)
                      : providerProfileModal.open();
                  }}
                  onStatusChange={() =>
                    handleStatusChange(user.id, user.active)
                  }
                />
              </Grid>
            );
          })}
        </Grid> */
  }
  return (
    <Box>
      <ScrollArea marginTop={"75px"} height="calc(100vh - 235px)">
        {ACTIVE_VIEW_MAPPER[curView as CurView]}
      </ScrollArea>
      <Flex
        justifyContent={{
          sm: "center",
          md: "flex-end",
        }}
        position={"fixed"}
        bottom={"50px"}
        right={"18px"}
        width={"96%"}
        bgcolor={"white"}
        zIndex={"1000"}
        padding={"0px 5px 5px 0px"}
      >
        <Flex alignItems={"center"} gap={"4px"}>
          <Text color={"text.primary"}>Current page:</Text>
          <Text color={"text.primary"}>{paginationModel.page + 1}</Text>
          <CustomTablePagination
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            rowCount={totalElements}
          />
        </Flex>
      </Flex>

      <ProviderProfileDrawer
        disClosureHost={providerProfileModal}
        providerUuid={selectedUserData?.uuid}
      />
      <UserProfileDrawer
        disClosureHost={userProfileModalDisclosure}
        userId={selectedUserData?.uuid}
        dialogTitle="User Profile"
      />

      <UpsertStaffUserDrawer
        open={opened}
        onClose={() => {
          close();
          setSelectedUserId(undefined);
        }}
        modalTitle={modalTitle as any}
        initialValues={
          modalTitle === "Edit User"
            ? ({
                ...userDetail?.data,
                workLocations: transformMultiSelectFrontEndVal(
                  (userDetail?.data as any)?.workLocations
                ),
              } as any)
            : null
        }
        onSubmit={editStaffUser}
      />
    </Box>
  );
};
export default UserDetails;
